var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","close":_vm.canExclude,"color":_vm.background,"text-color":_vm.foreground},on:{"input":_vm.exclude}},[_c('strong',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }